import { useState } from 'react'
import ActivityCard from '../../../../Core/Activity/ActivityCard';
import Table from './Table';
const Tab2 = ({ setSelectedCompanyAccounts, initialData, suppliername }) => {

  return (
    <div>
      <div
        className="row mb-3"
        style={{ border: "1px solid rgba(50, 50, 50, 0.35)", borderRadius: "5px" }}
      >
        <div className="col-12">
          <p className="boxLabel m-0">Default Payable Account</p>
          <Table
            setSelectedCompanyAccounts={setSelectedCompanyAccounts}
            initialData={initialData}
          />
        </div>
      </div>
      <div className="">
        <ActivityCard doctype="Supplier Group" docname={suppliername} />
      </div>
    </div>
  )
}

export default Tab2